<template>
  <div class="-card-view -skeleton">
    <div class="card-content">
      <div class="content-group -content-asset">
        <div class="group responsive-media"></div>
      </div>
      <div class="content-group -content-summary">
        <div class="group">
          <div class="summary-group">
            <h1 class="content-title">
              <span class="sub-title"> </span>
            </h1>
            <div class="primary-detail"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-actions">
      <div class="action-options">
        <div class="schedule-action"></div>
        <div class="content-actions"></div>
      </div>
    </div>
  </div>
</template>

<script setup></script>
